import React from 'react';
const Windowsvps = () => {
  return(
<>
    <div className="bg">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
            <h1 className="fs-1 text-center pt-5">Windows VPS Hosting</h1>
            <p className="text-center">Spinning up a remote desktop session has never been easier. Launch a new Windows Virtual Private server powered by the Microsoft native Hyper-v platform. Get fast access to your work on the go 24/7. Reliably run applications without interruption. Easily upgrade your environment as you grow. Join Today!</p>
            <div className="row mt-5">
                <div className="col-md-3 text-center">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">1 Slice Unavailable</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$NA</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>1</span> Cores</li>
                            <li><span> 2GB </span> Memory </li>
                            <li><span> 40GB</span> SSD Storage</li>
                            <li><span>2TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">2 Slices</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$10.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>1</span> Cores</li>
                            <li><span> 4GB </span> Memory </li>
                            <li><span> 80GB</span> SSD Storage</li>
                            <li><span>4TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">3 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$15.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>2</span> Cores</li>
                            <li><span> 6GB </span> Memory </li>
                            <li><span> 120GB</span> SSD Storage</li>
                            <li><span>6TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">4 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$20.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>2</span> Cores</li>
                            <li><span> 8GB </span> Memory </li>
                            <li><span> 160GB</span> SSD Storage</li>
                            <li><span>8TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-3 text-center">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">5 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$25.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>3</span> Cores</li>
                            <li><span> 10GB </span> Memory </li>
                            <li><span> 200GB</span> SSD Storage</li>
                            <li><span>10TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">6 Slices</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$30.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>3</span> Cores</li>
                            <li><span> 12GB </span> Memory </li>
                            <li><span> 240GB</span> SSD Storage</li>
                            <li><span>12TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">7 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$35.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>4</span> Cores</li>
                            <li><span> 14GB </span> Memory </li>
                            <li><span> 280GB</span> SSD Storage</li>
                            <li><span>14TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">8 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$40.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>4</span> Cores</li>
                            <li><span> 16GB </span> Memory </li>
                            <li><span> 320GB</span> SSD Storage</li>
                            <li><span>16TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
            </div>
            <div className="row mt-5 pt-5">
                <div className="col-md-4">
                    <img src="https://www.interserver.net/vps/assets/images/expert.png" className="w-100"/>
                </div>
                <div className="col-md-8 mt-5">
                    <p className="fs-2">Windows Remote Desktop</p>
                    <p>Access Your Windows Desktop 24/7 from any location. The system is always on and connected. Applications will continue to run even after you end your remote desktop session. Perfect for businesses with remote staff to access important files or software. Or run software in the background without interruption for data processing, currency mining, game servers, trading stocks or forex.</p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-8 mt-5 pt-5">
                    <p className="fs-2">24/7/365 Quick Support</p>
                    <p>Need any help? Our in-house expert team is always ready to assist you 24/7/365. All you need to reach us out via ticket system, phone call or live chat options. Our support department will resolve your problems day or night.</p>
                </div>
                <div className="col-md-4">
                    <img src="https://www.interserver.net/vps/assets/images/remote-d.png" className="w-100"/>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-4">
                    <img src="https://www.interserver.net/vps/assets/images/wh.png" className="w-100"/>
                </div>
                <div className="col-md-8 mt-5">
                    <p className="fs-2">Get More Power With Plesk for Windows</p>
                    <p>Plesk is an easy to use but a powerful control panel for Windows. Build and manage multiple sites from a single dashboard. You can also run updates, monitor performance and onboard new prospects all from the same place. Broad security levels across OS, network and apps. Built into the Plesk hosting control panel core and enhanced through our class-leading security partners. Do more with your platform as you integrate tools like DigiCert SSL, CloudLinux, Cloudflare, Atomicorp, NodeJs, PHP, NGINX, Let's Encrypt, Git, ImunifyAV, Backup to Cloud Pro and more. Save hours with One power tool to install, manage, update and secure all sites. Includes: automated AI-powered regression testing, cloning, staging environment, backup and restore features. More information on Plesk Prices and Features</p>
                </div>
            </div>
        </div>
    </div>
</>
    );
};
 
export default Windowsvps;